<template>
<div >

<div style="margin-top: 120px;" class="container d-flex justify-content-center ">
  
  <div class="jumbotron border border-primary w-100" style="max-width: 800px;">
    
    <h4 class="text-center">
      <i style='color:brown' class='fas fa-dolly mr-3'></i>
      
      TRASFERIMENTO ALTRA SEDE</h4>
    
    <p class="lead text-center">
      {{ cart.length }}  prodott{{ cart.length == 1 ? 'o' :'i' }}  da trasferire.
    </p>
    <p></p>
    <hr class="my-4"></hr>

    <form @submit.prevent="submit">  

      <div class="form-group">
        <label for="storeId"><strong>DESTINAZIONE</strong></label>    
        
        <select
          id="storeId"
          class="form-control"
          v-model="to_storeId"
          required
        >
          <option disabled value="">Seleziona destinazione</option>
          
          <option
            v-for="store in stores"
            :key="store.storeId"
            :value="store.storeId"
          >
            {{ store.store }}
          </option>
        </select>
      </div>

      <div class="form-check text-center">
        <input
          id="removeCartItems"
          type="checkbox"
          class="form-check-input"
          v-model="removeCartItems"
        >
        
        <label class="form-check-label" for="removeCartItems">
          RIMUOVI PRODOTTI A TRASFERIMENTO EFFETTUATO
        </label>
      </div>

      <hr class="my-4">

      <div class="d-flex justify-content-between">
        <button :disabled="closeBtn"
          type="button"
          class="btn btn-secondary"
          @click="close"
        >
          CHIUDI
        </button>

        <button
          type="submit"
          class="btn btn-primary"
        >
          <i class="fas fa-check-circle mr-2"></i>
          ESEGUI
        </button>
      </div>

    </form>
      
  </div>

</div>

   <!-- Modal MESSAGE -->  
   <modalMessage ref="msgModal"/>

</div>

</template>
<script>
import { mapGetters }        from 'vuex'
import api                   from '@/api'


import {addMessage}          from '@/api/Firebase'
import modalMessage          from '@/components/modalDialog/ModalMessage.vue'    

import { v4 as uuidv4 }      from 'uuid'
export default {
  
  props      : ['cart'],
  components : {modalMessage},
 
  data () 
  {
    return {
      
      stores              : [],
      to_storeId          : 0,
      
    
      removeCartItems     : true ,
      uuid                : '',
      closeBtn            : false
    }
  },
    computed: 
  {
    ...mapGetters(['storeId','company']) , 
  },
  mounted: function()
  {
    this.storeList()
  },
  created: function()
  {
    
    this.uuid = uuidv4()
    
  },
  methods :
  {
   
    async submit()
    {

      const body  = []      
      this.cart.forEach(item=>
      {
        body.push({'productId' : item.productId,'barcode' : item.barcode,'cost_price' : item.cost_price})      
      })
      
      const uuid      = this.uuid
      const companyId = this.company.Id
      const senderId  = this.storeId
      const storeId   = this.to_storeId      
      const sp        ='spCreateStockMovementToStore'

      const payload = {sp,companyId,storeId,senderId,body,uuid}
      
    try{

        this.closeBtn = true
        this.$refs.msgModal.show()   
        this.$refs.msgModal.setSpinner(true)
    
        const res = await api.post(payload)

        if (res.status !== 200) 
        {
          throw new Error(res.data ||  res)
        }

            const store         = res.data.recordsets[0][0].store
            const d             = new Date()
            const date          = d.toLocaleString()       
            const senderId      = this.storeId            
            const data          = date            
            const descrizione1  = store     
            if( process.env.NODE_ENV == 'production')           
            {
            addMessage({"date"          : data,            
                         "description1" : descrizione1, 
                         "description2" : '',  
                         "shippedFrom"  : senderId,
                         'shippedTo'    : this.to_storeId,
                         'rowId'        : Math.random() * this.storeId,
                         'total_qty'    : res.data.recordsets[0][0].total_qty
                        })  
             }           
             await this.$refs.msgModal.show('TRASFERIMENTO ESEGUITO.',{'title':'MESSAGGIO'},4)
             this.$emit('close',this.removeCartItems)
    
    

    /* =========================
       SUCCESSO
    ========================== */
      

          }
          catch (err) {
            
            this.$refs.msgModal.show(err.message,{},3)
            
          }
    },
    close()
    {
      this.$emit('close')                  
    }, 
    storeList()
    {
        this.stores = this.company.stores.filter(item => item.storeId != this.storeId)      
    },
 
  }
}
</script>    
<style scoped>



.form-check-label {
    color       : rgb(2, 52, 2);
    font-family : 'Roboto Condensed';
    font-size   : 18px;
    cursor      : pointer;
    font-weight : bold  ;
  }
</style>
